import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { LoginRequest } from "../interfaces/auth";
import { delay, retry } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class PortalService {
  public retryNo: number = 3;
  public delayNo: number = 1000;

  constructor(private _http: HttpClient) {}

  getProfile() {
    return this._http.get(`${environment.portalBEUrl}/backend/api/profile`);
  }

  doLogin(req: LoginRequest) {
    const body = JSON.stringify({
      username: req.username,
      password: req.password,
    });
    return this._http
      .post(`${environment.portalBEUrl}/backend/api/single_login`, body)
      .pipe(retry(this.retryNo), delay(this.delayNo));
  }
}
